eshopApp.controller('AddressesSelectorController', ['$scope', '$http', '$rootScope', function($scope, $http, $rootScope) {

    $rootScope.m_AddressesSelector = true;
    $rootScope.addressSuccess = false;

    $scope.spinner = false;

    $scope.hideCustomerList = true;
   
    // Customer
    $scope.customer = false;
    $scope.search = null;
    $scope.selectedCustomerIndex = null;

    // Addresses
    $scope.addresses = null;
    $scope.showNewAddressInput = false;
    $scope.selectedAddresses = {};
    $scope.selectedAddress1Details = null;
    $scope.selectedAddress2Details = null;

    // Get customers
    $scope.getCustomers = function() {
        $scope.spinner = true;

        $http.get('/a/customers', {
            params: {
                page: $scope.page,
                search: $scope.search
            }
        }).success(function(response) {
            if (response.message === 'success') {
                $scope.customers = response.data
            }
        }).finally(function() {
            $scope.spinner = false;
        });
    }
    $scope.$watch('search', function() {
        $scope.getCustomers();
    }),

    /**
     * Set customer and re-fetch the addresses.
     * @param {int} customerId
     * @param {int} index
     */
    $scope.setCustomer = function(customerId, index) {
        $rootScope.addressSuccess = false;
        $scope.addresses = null;
        $scope.selectedAddresses = {};
        $scope.selectedAddress1Details = null;
        $scope.selectedAddress2Details = null;

        $scope.customer = parseInt(customerId);
        $scope.selectedCustomerIndex = index;

        $http.post('/m/addressesselector/set_customer', {
            customer: $scope.customer
        }).success(function(response) {
            location.reload();
        }).error(function() {
            $scope.selectedCustomerIndex = null;
        }).finally(function() {

        });

        //$scope.getAddresses();
    }

    // Get customer addresses
    $scope.getAddresses = function() {
        $scope.spinner = true;

        var additional = '';
        if ($scope.customer) {
            additional = '/customer/' + $scope.customer;
        }

        $http.get('/a/addresses' + additional).success(function(response) {
            if (response.message === 'success') {
                $scope.addresses = response.data;
            }
        }).error(function() {
            $scope.selectedCustomerIndex = null;
        }).finally(function(){
            $scope.spinner = false;
        });
    }
    
    $scope.$watch('autoinit', function(value) {
        if (value) {
            $scope.getAddresses();
        }
    });

    // Set details for selected address
    $scope.setAddress1Details = function() {
        if (!$scope.addresses) {
            return false;
        }
        angular.forEach($scope.addresses, function(address, key){
            if (address.identifier === $scope.selectedAddresses.address1) {
                $scope.selectedAddress1Details = address;
            }
        });
        $scope.setAddresses();
    }
    $scope.setAddress2Details = function() {
        if (!$scope.addresses) {
            return false;
        }

        if ($scope.selectedAddresses.address2 == "new") {
            $scope.showNewAddressInput = true;
            return;
        }

        $scope.showNewAddressInput = false;

        angular.forEach($scope.addresses, function(address, key){
            if (address.identifier === $scope.selectedAddresses.address2) {
                $scope.selectedAddress2Details = address;
            }
        });
        $scope.setAddresses();
    }

   // Set addresses
    $scope.setAddresses = function() {
        $scope.spinner = true;

        $scope.selectedAddresses.customer = null;
        if ($scope.customer) {
            $scope.selectedAddresses.customer = $scope.customer;
        }

        $http.post('/m/addressesselector/set', $scope.selectedAddresses).success(function(response){
            $rootScope.addressSuccess = true;
            //$scope.nextStep();
        }).error(function() {
            $rootScope.addressSuccess = false;
        }).finally(function() {
            $scope.spinner = false;
        });
    }

    $scope.$watch('as.diff_billing_and_shipping', function(value) {
        if (value === false) {
            $scope.setAddresses();
        }
    });

    $scope.$watch('customer', function(value) {
        if (value) {
            $scope.getAddresses();
        }
    });

    $scope.saveNewAddress = function() {
        let form = new FormData();
        
        form.append('firstname', $scope.newAddressFirstName);
        form.append('lastname', $scope.newAddressLastName);
        form.append('company', $scope.newAddressCompany || '');
        form.append('address', $scope.newAddressStreet);
        form.append('postcode', $scope.newAddressZip);
        form.append('city', $scope.newAddressCity);
        form.append('country', $scope.newAddressCountry);
        form.append('address_label', $scope.newAddressLabel);
        form.append('_token', document.querySelector('input[name="_token"]').value);
        form.append('noRedirect', true);

        fetch('/dashboard/address', {
            method: 'POST',
            body: form,
            credentials: 'same-origin'
        })
        .then(function(response){
            if (response.ok) {
                window.location.reload();
            }
        });
    }

    // Emit showQuickRegister event via rootsScope
    /*$scope.showQuickRegister = function() {
        $rootScope.$emit('showQuickRegister', 'registered');
    }*/

    // Continue
    /*$scope.nextStep = function() {
        $rootScope.m_AddressesSelector = false;
        $rootScope.m_QuickRegister = false;
        $rootScope.m_FullCart = true;
        $rootScope.m_ShippingMethodSelector = true;
    }*/

}]);
